<template>
  <FormContainer withoutDivider>
    <template #title>Dénomination du CFA responsable</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_161"
          v-model="cfaEntrepriseModel"
          label="CFA d'entreprise"
          :items="OuiOuNon"
          :required="meta.formation?.estCfaEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.estCfaEntreprise?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
      <div class="form__bloc">
        <WrapperAutocomplete
          id="field_162"
          key-id="siret.valeur"
          key-label="denomination"
          v-model="cfaEtablissement"
          label="CFA responsable"
          hint="Siren ou Siret du CFA"
          class="col-24 col-md-20 col-sm-36"
          :search-min-length="9"
          :placeholder="PLACE_HOLDER_SIREN"
          :readonly
          strict
          :alertLabel="meta.formation?.cfaEtablissement?.$messageErreurDirty!"
          :required="meta.formation?.cfaEtablissement?.$status === PropertyStatus.Required"
          :search="searchPrestataire"
          :search-formater="sirenSiretSearchFormater"
        >
          <template v-slot="{ denomination, siret, adresse, estEtablissementSiege, etatAdministratif }">
            <div>
              <div>
                <BasicText weight="bold">{{ denomination }} - {{ siret.valeur }}</BasicText>
                <BasicText
                  v-if="estEtablissementSiege === true"
                  color="primary-600"
                >
                  - SIEGE
                </BasicText>
                <BasicText
                  v-if="etatAdministratif === 'F'"
                  color="red"
                >
                  (Inactif)
                </BasicText>
              </div>
              <div style="margin-top: -3px">
                <BasicText size="body-m">
                  {{ adresse?.voie }} {{ adresse?.codePostal }} {{ adresse?.commune }}
                </BasicText>
              </div>
            </div>
          </template>
        </WrapperAutocomplete>
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_167"
          :model-value="model?.formation?.cfaEtablissement?.siret?.valeur"
          label="SIRET"
          class="col-8 col-md-12 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_166"
          :model-value="model?.formation?.cfaEtablissement?.uai"
          label="N° UAI"
          :alertLabel="meta.formation?.cfaEtablissement?.uai?.$messageErreurDirty!"
          class="col-4 col-md-8 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_168"
          :model-value="model?.formation?.cfaEtablissement?.nda"
          label="N° d'activité"
          :alertLabel="meta.formation?.cfaEtablissement?.nda?.$messageErreurDirty!"
          class="col-4 col-md-8 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_164"
          :model-value="qualiopiLibelle"
          label="Qualiopi"
          :alertLabel="meta.formation?.cfaEtablissement?.certificationQualiopi?.$messageErreurDirty!"
          class="col-20 col-md-12 col-sm-36"
          disabled
          help="La certification Qualiopi est obligatoire pour tous les prestataires d'actions concourant au développement des compétences, et ce depuis le 1er janvier 2022."
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_170"
          :model-value="model?.formation?.cfaEtablissement?.adresse?.voie"
          :label="LABEL_NUMERO_VOIE"
          class="col-12 col-md-16 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_171"
          :model-value="model?.formation?.cfaEtablissement?.adresse?.complement"
          label="Complément d'adresse"
          class="col-12 col-md-16 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_172"
          :model-value="model?.formation?.cfaEtablissement?.adresse?.codePostal"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          disabled
        />
        <WrapperInput
          id="field_173"
          :model-value="model?.formation?.cfaEtablissement?.adresse?.commune"
          label="Commune"
          class="col-8 col-md-10 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { CertificationQualiopiLibelle } from '@/features/domaine/types/opco'
  import type { EtablissementPrestataireDTO } from '@/features/api/extranet/dto/shared'
  import { FormContainer, LABEL_NUMERO_VOIE, PLACE_HOLDER_SIREN } from '@/features/interface/demande/shared'
  import { CAPP_ACTIONS, type CappActions } from '@/features/interface/demande/capp/DemandeCAPP.type'
  import { sirenSiretSearchFormater } from '@/features/interface/shared/tools'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey } = store
  const { meta, model, readonly } = storeToRefs(store)
  const { searchPrestataire } = inject<CappActions>(CAPP_ACTIONS)!

  const cfaEtablissement = setupFieldWithKey<EtablissementPrestataireDTO>('formation.cfaEtablissement')
  const cfaEntrepriseModel = setupFieldWithKey<boolean>('formation.estCfaEntreprise', false)

  const qualiopiLibelle = computed(() => {
    return (
      model.value?.formation?.cfaEtablissement?.certificationQualiopi
        ?.map((item) => CertificationQualiopiLibelle[item])
        ?.join(', ') ?? ''
    )
  })
</script>
